import React, { useEffect, useState } from 'react';
import axios from '../../../axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react'


const EditCourses = () => {
    const {id} =useParams()
    const navigate = useNavigate()
    console.log(id)
    const toast = useToast()
    const [formData, setFormData] = useState({
        planName: '',
        planNameHin: '',
        desc: '',
        descHin: '',
        price: '',
        priceHin: '',
        offerPrice: '',
        offerPriceHin: '',
        planValidity: '',
        planValidityHin: '',
        planImage: '',
        planImageHin: '',
         scoreRules: {
    correct: "",
    wrong: "",
    skipped: "",
    rightLimit: "",
    wrongLimit: "",
    timeUp:"",
    rightLimit:"",
    wrongLimit:"",
    skipLimit:"",
    timeUpLimit:"",
  },
        exams: [],
        examsHin: [],
        subCourses: [],
        isActive: false,
      });
    
      const [allJobs, setAllJobs] = useState([]);
    
    useEffect(() => {
  axios.get("getAllCoursesForAdmin")
    .then((res) => {
      if (res.data) {
        const predata = res.data.result.find((el) => el._id === id);

        const { _id, __v, createdAt, ...filteredPredata } = predata;

        setFormData({
          ...filteredPredata,

          exams: predata.exams
            ? predata.exams.map((e) => e.examName)
            : [],

          examsHin: predata.exams
            ? predata.exams.map((e) => e.examNameHin)
            : [],
        });
      }
    });
}, [id]);
    
      useEffect(() => {
        axios
          .get('getAllInActiveCourses')
          .then((res) => {
            if (res.data) {
              setAllJobs(res.data.result);
              console.log('Loaded allJobs:', res.data.result);
            }
          })
          .catch((err) => {
            // toast.error("Failed to fetch jobs. Please try again.");
          });
      }, []);
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };

   const handleScoreRuleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    scoreRules: {
      ...prev.scoreRules,
      [name]: value,
    },
  }));
};
    
      const handleExamsChange = (e) => {
        const examsArray = e.target.value.split(',').map((exam) => exam.trim());
        setFormData((prevData) => ({
          ...prevData,
          exams: examsArray,
        }));
      };
    
      const handleExamsChangeHin = (e) => {
        const examsArray = e.target.value.split(',').map((exam) => exam.trim());
        setFormData((prevData) => ({
          ...prevData,
          examsHin: examsArray,
        }));
      };
    
      const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setFormData((prevData) => {
          const updatedSubCourses = checked
            ? [...prevData.subCourses, value]
            : prevData.subCourses.filter((subCourse) => subCourse !== value);
          console.log('Updated subCourses:', updatedSubCourses);
          return { ...prevData, subCourses: updatedSubCourses };
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Submitting formData:', formData); // Log formData to check subCourses
        axios.put(`editCourse/${id}`, formData)
          .then((res) => {
            if (res.data) {
                toast({
                    title: `Update! This course has been Updated`,
                    
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                     position:"top"
                  });
              navigate('/dash/view-course');
            }
          })
          .catch((err) => {
            toast({
                title: `Something Went Wrong!`,
                
                status: "error",
                duration: 4000,
                isClosable: true,
                 position:"top"
              });
          });
      };

  return (
    <div>
    
      <div className="m-6 py-4">
        <form onSubmit={handleSubmit}>
          <div className="bg-white shadow rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-xl font-bold text-purple">Edit Course</h3>
            </div>
        
            <div className="px-4 py-5 sm:p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Plan Name</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="planName"
                    value={formData.planName}
                    type="text"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Plan Name (Hindi)</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="planNameHin"
                    value={formData.planNameHin}
                    type="text"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Description</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="desc"
                    value={formData.desc}
                    type="text"
                    required
                    onChange={handleChange}
                  />
                </div>
             
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Price</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="price"
                    value={formData.price}
                    type="number"
                    required
                    onChange={handleChange}
                  />
                </div>
               
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Offer Price</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="offerPrice"
                    value={formData.offerPrice}
                    type="number"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Plan Validity</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="planValidity"
                    value={formData.planValidityDays}
                    type="text"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Total Questions</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="Total Questions"
                    value={formData.totalQuestions}
                    type="text"
                    required
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Plan Image</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="planImage"
                    value={formData.planImage}
                    type="text"
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Right Answer Bonus</label>
 <input
  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
  type="number"
  step="0.01"
  name="correct"
  value={formData.scoreRules?.correct ?? ""}
  onChange={handleScoreRuleChange}
/>
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Wrong Answer Penalty</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    type="number"
                    step="0.01"
                    name="wrong"
                    value={formData?.scoreRules?.wrong ?? ""}
                    required
                    onChange={handleScoreRuleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Skipped Answer Penalty</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="isSkip"
                    value={formData?.scoreRules?.skipped}
                    type="number"
                    step="0.01"
                    required
                    onChange={handleScoreRuleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Right Answer Limit</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="rightLimit"
                    value={formData?.scoreRules?.rightLimit}
                    type="number"
                    step="0.01"
                    required
                    onChange={handleScoreRuleChange}
                  />
                </div>
            
                <div>
                  <label className="block text-sm  text-start font-medium text-gray-700">Wrong Answer Limit</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="wrongLimit"
                    value={formData?.scoreRules?.wrongLimit}
                    type="number"
                    step="0.01"
                    required
                    onChange={handleScoreRuleChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Exams</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="exams"
                    value={formData.exams.join(', ')}
                    type="text"
                    required
                    onChange={handleExamsChange}
                  />
                </div>
                <div>
                  <label className="block text-sm text-start font-medium text-gray-700">Exams (Hindi)</label>
                  <input
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    name="examsHin"
                    value={formData.examsHin.join(', ')}
                    type="text"
                    required
                    onChange={handleExamsChangeHin}
                  />
                </div>
                <div className="text-start">
                  <label className=" text-sm text-start font-medium text-gray-700">Select SubCourses</label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {allJobs?.map((job) => (
                      <div key={job._id} className="flex items-center">
                        <input
                          type="checkbox"
                          name="subCourses"
                          value={job._id}
                          checked={formData.subCourses.includes(job._id)}
                          onChange={handleCheckboxChange}
                          className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <label className="ml-2 text-sm text-start text-gray-700">{job.planName}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Edit Course
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCourses;
